function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from "react";
import UseCasesTabsComponent from "segments/desktop/tabs/layouts/use-cases-tabs/use-cases-tabs-component";
import Colors from "styles/colors";
import { StyledProcessTabsMobile } from "./process-tabs-mobile.scss";
const ProcessTabsMobile = ({ tabs, tabsColor, autoTransition, titleConfig, tabBackgroundColor })=>{
    const getTabAssetFullParagraph = useCallback((tab)=>_object_spread_props(_object_spread(_object_spread_props(_object_spread({}, tab.title || {
            title: ""
        }), {
            topic: {},
            body: null
        }), titleConfig), {
            titleClassName: "asset-title"
        }), [
        titleConfig
    ]);
    const mobileTabs = useMemo(()=>tabs.map((tab)=>({
                tabLabel: tab.tabLabel,
                tabContent: {
                    asset: null,
                    mobileAsset: tab.asset,
                    images: [
                        {
                            src: null,
                            fullParagraph: getTabAssetFullParagraph(tab)
                        }
                    ]
                }
            })), [
        getTabAssetFullParagraph,
        tabs
    ]);
    return /*#__PURE__*/ _jsx(StyledProcessTabsMobile, {
        className: "process-tabs-mobile",
        style: {
            "--tab-color": Colors[tabsColor],
            backgroundColor: tabBackgroundColor
        },
        children: /*#__PURE__*/ _jsx(UseCasesTabsComponent, {
            tabs: mobileTabs,
            autoplaySpeed: autoTransition
        })
    });
};
export default ProcessTabsMobile;
